import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core";

import { KEY_V } from "../../util/UtilKeys";

export const useStyles = makeStyles((theme) => ({
  tagContainer: {
    position: "absolute",
    bottom: 10,
    right: 10,
    border: `3px outset ${theme.palette.content.mainColor}`,
    padding: 10,
    borderRadius: "15px",
  },
}));

//Hidden version tag
export default function VersionTag() {
  const classes = useStyles();
  const [showVersion, setShowVersion] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      const { keyCode, altKey } = e;
      if (altKey && keyCode === KEY_V) {
        e.preventDefault();
        setShowVersion((show) => !show);
      }
    };
    window.addEventListener("keydown", handler);
    return () => {
      window.removeEventListener("keydown", handler);
    };
  }, []);

  if (showVersion === true && process.env.REACT_APP_VERSION) {
    return (
      <div className={classes.tagContainer}>
        v{process.env.REACT_APP_VERSION}
        {process.env.NODE_ENV === "development" && " (DEV)"}
      </div>
    );
  } else {
    return null;
  }
}
